/* BR4NDOM · White/Lines (Swiss) · interactions (all guarded) */
(function () {
  'use strict';

  /* Intro counter + curtain removal */
  var intro = document.getElementById('sw-intro');
  if (intro) {
    var c = document.getElementById('sw-intro-count');
    if (c) {
      var D = 1900, t0 = performance.now(), pad = function (n) { return String(n).padStart(3, '0'); };
      var tick = function (n) { var t = Math.min((n - t0) / D, 1); c.textContent = pad(Math.round(t * 100)); if (t < 1) requestAnimationFrame(tick); };
      requestAnimationFrame(tick);
    }
    intro.addEventListener('animationend', function (e) { if (e.target === intro) intro.classList.add('sw-intro--done'); });
  }

  /* Scroll reveal */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: .1 });
  document.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });

  /* Product page · thumbnails + size selection */
  var thumbs = document.querySelectorAll('.pdp__thumb');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      var i = t.getAttribute('data-i');
      document.querySelectorAll('#pdp-main .pg').forEach(function (im) { im.classList.toggle('actif', im.getAttribute('data-i') === i); });
      thumbs.forEach(function (x) { x.classList.remove('actif'); });
      t.classList.add('actif');
    });
  });
  var sizes = document.querySelectorAll('#sizes .size');
  var hidden = document.getElementById('variant-id');
  sizes.forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.hasAttribute('disabled')) return;
      sizes.forEach(function (x) { x.classList.remove('choisie'); });
      b.classList.add('choisie');
      if (hidden) hidden.value = b.getAttribute('data-id');
    });
  });

  /* Zoom lightbox on product images */
  var galMain = document.getElementById('pdp-main');
  var lb = document.getElementById('lightbox');
  if (galMain && lb) {
    var lbImg = lb.querySelector('img');
    galMain.addEventListener('click', function () {
      var act = galMain.querySelector('.pg.actif') || galMain.querySelector('.pg');
      if (!act) return;
      lbImg.src = act.getAttribute('data-zoom') || act.src;
      lb.classList.add('on'); lb.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
    });
    var closeLb = function () { lb.classList.remove('on'); lb.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };
    lb.addEventListener('click', closeLb);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLb(); });
  }

  /* Size guide modal */
  var sg = document.getElementById('sizeguide');
  var sgOpen = document.getElementById('sizeguide-open');
  if (sg && sgOpen) {
    var sgClose = document.getElementById('sizeguide-close');
    var openSg = function () { sg.classList.add('on'); sg.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; };
    var shutSg = function () { sg.classList.remove('on'); sg.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };
    sgOpen.addEventListener('click', openSg);
    if (sgClose) sgClose.addEventListener('click', shutSg);
    sg.addEventListener('click', function (e) { if (e.target === sg) shutSg(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sg.classList.contains('on')) shutSg(); });
  }

  /* Announcement bar · closing it only silences it for this visit */
  var ann = document.getElementById('annbar');
  if (ann) {
    var ANNOFF = 'brd_ann_off';
    try { if (sessionStorage.getItem(ANNOFF)) ann.hidden = true; } catch (e) {}
    var annClose = document.getElementById('annbar-close');
    if (annClose) annClose.addEventListener('click', function () {
      ann.hidden = true;
      try { sessionStorage.setItem(ANNOFF, '1'); } catch (e) {}
    });
  }

  /* Newsletter · storage helpers */
  var DONE = 'brd_news_done', SRC = 'brd_news_src', POS = 'brd_news_pos';
  var get = function (store, k) { try { return window[store].getItem(k); } catch (e) { return null; } };
  var set = function (store, k, v) { try { window[store].setItem(k, v); } catch (e) {} };
  var del = function (store, k) { try { window[store].removeItem(k); } catch (e) {} };

  /* Older versions flagged DONE ('1') when the popup was merely closed, which
     silenced it for good. Only a real signup ('sub') retires it now, so drop
     the ambiguous old flag and let those visitors be asked again. */
  var doneFlag = get('localStorage', DONE);
  if (doneFlag && doneFlag !== 'sub') del('localStorage', DONE);

  /* Shopify posts the customer form to /contact#contact_form, so the browser
     jumps to the footer form on the way back. Put the reader back where it was. */
  var newsForms = document.querySelectorAll('#news-footer-form, #news-popup-form, #news-bar-form');
  newsForms.forEach(function (f) {
    f.addEventListener('submit', function () { set('sessionStorage', POS, String(window.scrollY)); });
  });
  if (window.BR_NEWS_OK || window.BR_NEWS_ERR) {
    var pos = get('sessionStorage', POS);
    if (pos !== null) {
      del('sessionStorage', POS);
      window.scrollTo(0, parseInt(pos, 10) || 0);
    }
  }

  /* Newsletter popup (optional · Theme settings > Newsletter) */
  var pop = document.getElementById('newspop');
  if (pop) {
    var POPOFF = 'brd_news_pop_off';
    var openPop = function () { pop.classList.add('on'); pop.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; };
    // Closing only silences it for this visit: it asks again next time they come back.
    var shutPop = function () { pop.classList.remove('on'); pop.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; set('sessionStorage', POPOFF, '1'); };

    // Only an actual signup (from anywhere) retires the popup for good.
    if (window.BR_NEWS_OK) set('localStorage', DONE, 'sub');

    // Remember which form was used, so we can reopen the popup on its own result.
    var popForm = pop.querySelector('form');
    if (popForm) popForm.addEventListener('submit', function () { set('sessionStorage', SRC, 'popup'); });

    var fromPopup = get('sessionStorage', SRC) === 'popup';
    var posted = window.BR_NEWS_OK || window.BR_NEWS_ERR;

    if (posted && fromPopup) {
      del('sessionStorage', SRC);
      openPop();
    } else if (!posted && window.BR_NEWS_POPUP_ON && !get('localStorage', DONE) && !get('sessionStorage', POPOFF)) {
      setTimeout(openPop, (window.BR_NEWS_POPUP_DELAY || 8) * 1000);
    }

    var popClose = document.getElementById('newspop-close');
    if (popClose) popClose.addEventListener('click', shutPop);
    pop.addEventListener('click', function (e) { if (e.target === pop) shutPop(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('on')) shutPop(); });
  }

  /* Newsletter sticky bar · follows the scroll, steps aside for the real band */
  var bar = document.getElementById('newsbar');
  if (bar) {
    var BAROFF = 'brd_news_bar_off';
    var band = document.getElementById('newsletter');
    var barForm = document.getElementById('news-bar-form');
    var scrolled = false, bandSeen = false, retired = false;

    var refreshBar = function () {
      var show = !retired && scrolled && !bandSeen &&
                 !(pop && pop.classList.contains('on'));
      bar.classList.toggle('on', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    };
    var retireBar = function () { retired = true; refreshBar(); };

    if (barForm) barForm.addEventListener('submit', function () { set('sessionStorage', SRC, 'bar'); });

    // Signed up, popup dismissed, or bar closed earlier: stay out of the way.
    if (!window.BR_NEWS_BAR_ON || window.BR_NEWS_OK ||
        get('localStorage', DONE) || get('sessionStorage', BAROFF)) retired = true;

    // Confirm in place when the signup came from the bar itself.
    if (window.BR_NEWS_OK && get('sessionStorage', SRC) === 'bar') {
      del('sessionStorage', SRC);
      var pitch = bar.querySelector('.newsbar__txt:not(.newsbar__ok)');
      var okTxt = bar.querySelector('.newsbar__ok');
      var formWrap = bar.querySelector('form');
      if (formWrap) formWrap.remove();
      if (pitch) pitch.hidden = true;
      if (okTxt) okTxt.hidden = false;
      retired = false; scrolled = true; bandSeen = false;
      refreshBar();
      setTimeout(retireBar, 5000);
    }

    if (band && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bandSeen = entries[0].isIntersecting;
        refreshBar();
      }, { rootMargin: '0px 0px -10% 0px' }).observe(band);
    }

    var onScroll = function () {
      var next = window.scrollY > 120;
      if (next !== scrolled) { scrolled = next; refreshBar(); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var barClose = document.getElementById('newsbar-close');
    if (barClose) barClose.addEventListener('click', function () {
      set('sessionStorage', BAROFF, '1');
      retireBar();
    });
  }

})();
